export default { sha: 'f87f2ecc93a1e5ad96b405fa5889fe4be649e42a', buildNumber: 'undefined' }
